import * as classNames from "classnames";
import * as update from "immutability-helper";
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Map } from './Map';
import * as Configuration from '../../configuration';
import { ITab } from "../../configuration/ICustomConfiguration";
import { MapState } from '../../reducers/map.reducer';
import * as DashboardActionCreators from "../../actions/dashboard.actions";
import * as MapActionCreators from "../../actions/map.actions";
import { IAppState } from "../../app";
import * as DTOS from "../../FeralScan.dtos";


type MapContainerProps = {
    // passed down
    activeTab: ITab;
    googleMapURL: string;
    gridSize: number;
    mapType: string;
    markers: JSX.Element[];
    newMarker: JSX.Element;
    zoomInOnClick: boolean;
}

type MapContainerPropsMapped = {
    // map from state
    map: MapState;
    layers: any[];
    loading: boolean;
}

type MapContainerActions = {
    // passed down
    changeTab(tab: string, type?: string): void;
}

type MapContainerActionsMapped = {
    cacheMapSettings: typeof MapActionCreators.cacheMapSettingsAction;
    toggleMapOptions: typeof MapActionCreators.toggleMapOptionsRequest;
    toggleMarkerPopup: typeof MapActionCreators.toggleMarkerPopupRequest;
    toggleNewMarkerPopup: typeof MapActionCreators.toggleNewMarkerPopupRequest;
}

type MapContainerAllPropsInherited = MapContainerProps & MapContainerActions;
type MapContainerAllPropsMapped = MapContainerPropsMapped & MapContainerActionsMapped;

export type MapContainerAllProps = MapContainerAllPropsInherited & Partial<MapContainerAllPropsMapped>;

class MapContainer extends React.PureComponent<MapContainerAllProps, any> {

    constructor(props, context) {
        super(props, context);

        this.onShowLegend = this.onShowLegend.bind(this);
        this.onShowLayers = this.onShowLayers.bind(this);
        this.onLayerSelected = this.onLayerSelected.bind(this);
        this.onShowMapTypeOptions = this.onShowMapTypeOptions.bind(this);
    }

    onShowLayers() {
        this.props.toggleMapOptions("Layers");

    }
    onShowLegend() {
        this.props.toggleMapOptions("Legend");
    }
    onChangeTab(tab: string) {
        this.props.changeTab(tab);
    }

    onShowMapTypeOptions() {
        this.props.toggleMapOptions("MapType");
    }

    onLayerSelected(layer, selected) {
        var newItems = this.state.selectedLayers;
        var exisitingLayer = newItems.find(i => i.id == layer.id);
        if (selected === true && exisitingLayer === undefined) {
            newItems = update(this.state.selectedLayers, {
                $push: [layer]
            });

        } else if (selected === false && exisitingLayer !== undefined) {
            let index = newItems.indexOf(exisitingLayer);
            newItems = update(this.state.selectedLayers, {
                $splice: [[index, 1]]
            });
        }
        this.setState({ selectedLayers: newItems });
    }

    render() {

        const showMapTypeOptions: boolean = this.props.map.openMapOptions['MapType'] === true;
        const showLegendOptions: boolean = this.props.map.openMapOptions['Legend'] === true;
        const showLayersOptions: boolean = this.props.map.openMapOptions['Layers'] === true;

        const optionsMapType = showMapTypeOptions ? <div className="btn-group-vertical btn-group-sm btn-block" data-toggle="buttons">
            <label className={`map-overlay-btn mt-2 ${this.props.mapType == "normal" ? "active" : ""}`} onClick={undefined/*this.onMapTypeClicked.bind(this, MapType.normal)*/}>
                <i className={`col-1 fa ${this.props.mapType == "normal" ? "fa-check" : ""}`}></i>
                <span className="col-11">Normal Map</span>
            </label>
            <label className={`map-overlay-btn ${this.props.mapType == "clustered" ? "active" : ""}`} onClick={undefined/*this.onMapTypeClicked.bind(this, MapType.clustered)*/}>
                <i className={`col-1 fa ${this.props.mapType == "clustered" ? "fa-check" : ""}`}></i>
                <span className="col-11">Clustered Map</span>
            </label>
            <label className={`map-overlay-btn ${this.props.mapType == "heat" ? " active" : ""}`} onClick={undefined/*this.onMapTypeClicked.bind(this, MapType.heat)*/}>
                <i className={`col-1 fa ${this.props.mapType == "heat" ? "fa-check" : ""}`}></i>
                <span className="col-11">Heat Map</span>
            </label>
        </div> : undefined;

        const optionsLegend = showLegendOptions ?
            <div className="mx-1 py-2" >
                {//this.props.legend.map((l, i) => <div key={i} className="my-1"> <img src={l.icon} height="16" /> {l.label}</div>)
                }
            </div> : undefined;

        const optionsLayers = showLayersOptions ?
            <div className="mx-1 py-2" >
                <div className="mx-3">
                    {this.props.layers ? this.props.layers.map((l, i) => {
                        var selected = false;//!this.state.selectedLayers || this.state.selectedLayers.find(i => i.id == l.id) == undefined ? false : true;

                        return <div key={i} className="row mt-3" >
                            <div className="col-12 p-2" style={{ borderBottom: `${l.layerColour} 3px solid` }}>
                                <div className="btn-group-sm small pull-right">
                                    <div className={classNames("btn", { "btn-secondary active": selected, "btn-secondary": !selected })}
                                        onClick={this.onLayerSelected.bind(this, l, true)}>
                                        on
                                                </div>
                                    <div className={classNames("btn", { "btn-danger": !selected, "btn-secondary": selected })}
                                        onClick={this.onLayerSelected.bind(this, l, false)}>
                                        off
                                                </div>
                                </div>
                                {l.name}</div>
                        </div>;
                    }) : undefined}
                </div>
            </div> : undefined;

        var zoom = this.props.map.cachedZoom ? this.props.map.cachedZoom : this.props.map.defaultZoom != undefined ? this.props.map.defaultZoom : 5;
        var latitude = this.props.map.cachedLatLong ? this.props.map.cachedLatLong.latitude : this.props.map.defaultLatitude ? this.props.map.defaultLatitude : -25.612545;
        var longitude = this.props.map.cachedLatLong ? this.props.map.cachedLatLong.longitude :this.props.map.defaultLongitude ? this.props.map.defaultLongitude : 134.938092;

        const mapTypeId = this.props.activeTab && this.props.activeTab.mapTabSettings.mapTypeId ? this.props.activeTab.mapTabSettings.mapTypeId : Configuration.custom.defaultMapTypeId;
        
        return (
            <div className="map-container">
                <Map
                    cacheMapSettings={this.props.cacheMapSettings}
                    defaultZoom={zoom}
                    height={"100%"}
                    interactive={true}
                    googleMapURL={this.props.googleMapURL}
                    gridSize={this.props.gridSize}
                    key={'map-container-gmap-' + mapTypeId} // needs key based on maptype so it knows to rerender when it changes
                    lat={latitude}
                    layers={undefined} //this.state.selectedLayers}
                    lng={longitude}
                    mapType={this.props.mapType}
                    mapTypeId={mapTypeId}
                    markers={this.props.markers}
                    newMarker={this.props.newMarker}
                    
                    toggleNewMarkerPopup={this.props.activeTab.mapTabSettings.mapEnablePlotCreation ? this.props.toggleNewMarkerPopup : undefined}
                    zoomInOnClick={this.props.zoomInOnClick}
                />

                {this.props.activeTab.mapTabSettings.showMapOptions ?
                    <div style={{
                        position: "absolute",
                        top: 10,
                        right: 100
                    }}>
                        <div className="btn-group-sm d-none d-md-block">
                            <button onClick={this.onShowMapTypeOptions} className={classNames("btn-map-toolbar btn btn-default"//, { "active": this.state.showCluster }
                            )}>Map Type</button>
                            <button onClick={this.onShowLegend} className={classNames("btn-map-toolbar btn btn-default"//, { "active": this.state.showLegend }
                            )}>Legend</button>
                            <button onClick={this.onShowLayers} className={classNames("btn-map-toolbar btn btn-default"//, { "active": this.state.showLayers }
                            )}>Layers</button>
                            <div className="map-overlay small">{optionsLegend}{optionsLayers}{optionsMapType}</div>
                        </div>

                    </div> : undefined
                }

                {this.props.activeTab.mapTabSettings.showAddPlotEventButton ?
                    <div style={{
                        position: "absolute",
                        bottom: 50,
                        left: 50,
                        height: 50,
                        width: 50
                    }}>
                        <div className={classNames("btn-circle-wrapper")}>
                            <button onClick={this.onChangeTab.bind(this, Configuration.SurveyTab)} className={classNames("btn-map-toolbar btn btn-default btn-circle btn-large-text")}>+</button>
                        </div>
                    </div>
                    : undefined
                }
            </div>);
    }
}

const mapStateToProps = (state: IAppState): MapContainerPropsMapped => {
    return {
        layers: state.data.layers,
        loading: state.data.plotsLoading,
        map: state.map
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<MapContainerActionsMapped>({
        cacheMapSettings: MapActionCreators.cacheMapSettingsAction,
        toggleNewMarkerPopup: MapActionCreators.toggleNewMarkerPopupRequest,
        toggleMapOptions: MapActionCreators.toggleMapOptionsRequest,
        toggleMarkerPopup: MapActionCreators.toggleMarkerPopupRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)<MapContainerAllPropsInherited>(MapContainer);
